<template>
  <div>
    <div class="mb-2">
      <div
        class="header-purple d-flex justify-content-between align-items-center"
      >
        <div>
          <p class="mb-0 text-black"><strong>รูปภาพปก</strong></p>
        </div>
        <div>
          <p class="mb-0 text-gray-1">อัพเดทล่าสุด : {{ updatedDate }}</p>
        </div>
      </div>
      <div class="p-4 bg-white">
        <b-row>
          <b-col md="6">
            <div
              class="image-preview"
              v-bind:style="{
                'background-image': 'url(' + form.thumbnail.imageUrl + ')',
              }"
            >
              <img
                src="/img/loading.svg"
                class="loading"
                alt="loading"
                v-if="isLoadingModal"
              />
            </div>
          </b-col>
          <b-col md="6">
            <UploadFile
              textFloat="รูปสินค้า"
              placeholder="กรุณาเลือกไฟล์"
              format="image"
              name="thumbnail"
              v-model="form.thumbnail.imageUrl"
              :fileName="form.thumbnail.imageUrl"
              text="* อัพโหลดได้เฉพาะไฟล์ .png, .jpg ขนาด 1,000 x 1,000 ไม่เกิน 10 MB"
              isRequired
              v-on:onFileChange="onImageModalChange"
              v-on:delete="deleteImage"
              :v="$v.form.thumbnail.imageUrl"
              :isDisplayDeleteIcon="true"
            />
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="mt-2" v-if="[1, 2].includes(productOption)">
      <div class="header-purple">
        <div>
          <p class="mb-0">
            <strong class="text-black"
              >รูปภาพ (สามารถใส่ได้ไม่เกิน 8 รูป)</strong
            >
            <span class="text-purple1 f-size-14">
              รองรับแค่ไฟล์ .jpg .png สำหรับรูปภาพ และ .mp4 สำหรับวิดีโอ
              (ความจุไม่เกิน 10 MB)
            </span>
          </p>
        </div>
      </div>
      <div class="p-4 bg-white">
        <ProductImage
          :dataList="form.productImage"
          @updateImageList="updateImageList"
          :v="$v.form.productImage"
          @deleteImageOption="deleteImageOption"
          @displayImage="displayImage"
        >
          <template v-slot:label-title>
            <span> รูปภาพทั่วไป </span>
          </template>
        </ProductImage>
      </div>
    </div>
    <div v-if="productOption === 2" class="mt-2">
      <div
        class="mt-2"
        v-for="(imageConfig, cindex) in form.productAttributeImage"
        :key="cindex"
      >
        <div class="header-purple">
          <div>
            <p class="mb-0">
              <strong class="text-black"
                >รูปภาพ (สามารถใส่ได้ไม่เกิน 8 รูป)</strong
              >

              <span class="text-purple1 f-size-14">
                รองรับแค่ไฟล์ .jpg .png สำหรับรูปภาพ และ .mp4 สำหรับวิดีโอ
                (ความจุไม่เกิน 10 MB)
              </span>
            </p>
          </div>
        </div>

        <div class="p-4 bg-white">
          <ProductImage
            :dataList="imageConfig.image"
            @updateImageList="updateImageAttributeList"
            :v="$v.form.productAttributeImage.$each.$iter[cindex].image"
            :productIndex="cindex"
            @deleteImageOption="deleteImageAttributeList"
            @displayImage="displayImageAttributeList"
          >
            <template v-slot:label-title>
              <span> รูปภาพสินค้า {{ imageConfig.altTag }}</span>
            </template>
          </ProductImage>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <div class="p-2 bg-white">
        <b-container class="p-0">
          <b-row class="no-gutters">
            <b-col md="6" class="d-flex">
              <b-button
                class="btn-main-3"
                @click="$emit('handleRoute')"
                >ยกเลิก</b-button
              >
            </b-col>
            <b-col md="6" class="d-flex justify-content-md-end mt-3 mt-md-0">
              <!-- <b-button
                class="btn-main"
                @click="checkForm(0)"
                :disabled="isDisable"
                >บันทึกแบบร่าง</b-button
              > -->
              <b-button
                class="ml-2 btn-main"
                @click="checkForm(1)"
                :disabled="isDisable"
                >บันทึก</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import UploadFile from "../../../../../components/inputs/UploadFile.vue";
import ProductImage from "./ProductImage.vue";
import { required } from "vuelidate/lib/validators";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  name: "ProductImangePanel",
  components: {
    UploadFile,
    ProductImage,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  props: {
    productTypeId: {
      required: true,
      type: Number,
    },
  },
  data: function () {
    return {
      isLoadingModal: false,
      isDisable: false,
      images: "",
      imageBase64: "",
      updatedDate: new Date().toDateString(),
      modalMessage: "",
      flag: 0,
      form: {
        thumbnail: {
          productId: 0,
          imageUrl: "",
          imageBase64: null,
          hoverImageUrl: "",
          hoverImageBase64: null,
        },
        productImage: [],
        productImageRemove: [],
        productAttributeImage: [],
      },
    };
  },
  validations: {
    form: {
      thumbnail: {
        imageUrl: { required },
      },
      productImage: { required },
      productAttributeImage: {
        $each: {
          image: { required },
        },
      },
    },
  },
  created: async function () {
    this.id = parseInt(this.$route.params.id);
    await this.getThumbnailData();
  },
  computed: {
    productOption() {
      return this.productTypeId;
    },
  },
  mounted() {},
  methods: {
    hadleModalAlertClose() {
      if (this.flag == 0) {
        this.getThumbnailData();
      } else {
        this.$router.push(`/product?brandID=${this.$route.params.brandID}`);
      }
    },
    checkForm: async function (flag) {
      this.flag = flag;
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      await this.saveThumbnail();
    },
    saveThumbnail: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/product/saveThumbnail`, this.form)
        .then((data) => {
          this.isDisable = false;
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
        });
    },
    getThumbnailData: async function () {
      await this.axios
        .get(`${this.$baseUrl}/product/thumbnail/${this.id}`)
        .then((thumbnailData) => {
          if (thumbnailData.result == 1) {
            this.form = thumbnailData.detail;
          }
        });
    },
    onImageModalChange(img) {
      this.isLoadingModal = true;
      this.isDisable = true;
      var reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = async () => {
        this.saveImagetoDb(reader.result).then((imageUrl) => {
          this.form.thumbnail.imageUrl = imageUrl.url;
          this.isLoadingModal = false;
          this.isDisable = false;
        });
      };
    },
    handleChangeImageList(imageList) {
      this.form.imageList = imageList;
    },
    deleteImage(value) {
      this.form.thumbnail.imageUrl = "";
    },
    saveImagetoDb: async function (img) {
      var imgData = {
        Base64: img,
      };

      return new Promise((resolve, reject) => {
        this.axios
          .post(`${this.$baseUrl}/product/SaveImage`, imgData)
          .then((data) => {
            if (data.result == 1) {
              resolve({ url: data.detail.url, isVideo: data.detail.isVideo });
            } else {
              reject(data);
            }
          });
      });
    },
    updateImageList(list) {
      this.form.productImage = list;
    },
    updateImageAttributeList(list, index) {
      let images = [];
      list.forEach((image) => {
        images.push({
          base64: image.base64,
          display: image.display,
          imageUrl: image.imageUrl,
          sortOrder: image.sortOrder,
        });
      });
      this.form.productAttributeImage[index].image = images;
    },
    deleteImageOption(value) {
      if (value.imageId) {
        this.form.productImageRemove.push(value.imageId);
      }
    },
    deleteImageAttributeList(data, list, index) {
      this.form.productAttributeImage[index].image = list;
    },
    displayImage(list) {
      this.form.productImage = list;
    },
    displayImageAttributeList(list, index) {
      this.form.productAttributeImage[index].image = list;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-purple {
  padding: 1rem 1.5rem;
  background: #e0e1f4;
}

.image-preview {
  width: 100%;
  padding-bottom: 55%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  border: 2px dashed #bfbfbf;
  margin-bottom: 15px;
  position: relative;
}

.button-container {
  min-width: 150px;
  @media only screen and (max-width: 400px) {
    min-width: auto;
  }
}
</style>
